import axiosInstance from './axiosInstance';
import {
  FiltersCitiesQueryParamsDto,
  FiltersClinicsQueryParamsDto,
  StatsPerCityQueryParamsDto,
  StatsPerClinicsQueryParamsDto,
  StatsPerProfessionalsQueryParamsDto,
  Specialization,
  PlatformStatisticsQueryParamsDto,
  PlatformStatisticResponseDto,
} from '@docbay/schemas';

/**
 * Statistics API
 */
export const StatisticsApi = {
  /**
   * Fetch cities statistics
   * @param params - FiltersCitiesQueryParamsDto
   * @returns Promise<any>
   */
  fetchCities: (params: FiltersCitiesQueryParamsDto) =>
    axiosInstance.post<any>('/statistics/filters/cities', params),

  /**
   * Fetch clinics statistics
   * @param params - FiltersClinicsQueryParamsDto
   * @returns Promise<any>
   */
  fetchClinics: (params: FiltersClinicsQueryParamsDto) =>
    axiosInstance.post<any>('/statistics/filters/clinics', params),

  /**
   * Fetch per city metrics
   * @param params - StatsPerCityQueryParamsDto
   * @returns Promise<any>
   */
  fetchPerCityMetrics: (params: StatsPerCityQueryParamsDto) =>
    axiosInstance.post<any>('/statistics/per-city', params),

  /**
   * Fetch per clinics metrics
   * @param params - StatsPerClinicsQueryParamsDto
   * @returns Promise<any>
   */
  fetchPerClinicsMetrics: (params: StatsPerClinicsQueryParamsDto) =>
    axiosInstance.post<any>('/statistics/per-clinic', params),

  /**
   * Fetch per doctors metrics
   * @param params - StatsPerProfessionalsQueryParamsDto
   * @returns Promise<any>
   */
  fetchPerDoctorsMetrics: (params: StatsPerProfessionalsQueryParamsDto) =>
    axiosInstance.post<any>('/statistics/per-professional', params),

  /**
   * Fetch specializations
   * @returns Promise<Specialization[]>
   */
  fetchSpecializations: () =>
    axiosInstance.get<Specialization[]>('/specializations'),

  /**
   * Fetch platform statistics
   * @param params - PlatformStatisticsQueryParamsDto
   * @returns Promise<PlatformStatisticResponseDto>
   */
  fetchPlatformStatistics: (params: PlatformStatisticsQueryParamsDto) =>
    axiosInstance.post<PlatformStatisticResponseDto>(
      '/statistics/platform',
      params,
    ),
};
